import { apiRequest } from "./api";
import type { GigRequestMessageResponse } from "../types/gigTypes";

export type RealtimeSessionResponse = {
  websocketUrl: string;
  ticket: string;
  expiresAt: string;
};

export type GigRequestMessageCreatedRealtimeEvent = {
  type: "gig_request_message.created";
  message: GigRequestMessageResponse;
};

export type RealtimeEvent = GigRequestMessageCreatedRealtimeEvent;

export const realtimeApi = {
  createSession(): Promise<RealtimeSessionResponse> {
    return apiRequest<RealtimeSessionResponse>("/api/realtime/session", {
      method: "POST",
    });
  },
};

export function parseRealtimeEvent(payload: string): RealtimeEvent | null {
  try {
    const parsed = JSON.parse(payload) as Partial<RealtimeEvent> | null;
    if (!parsed || typeof parsed !== "object" || parsed.type !== "gig_request_message.created") {
      return null;
    }
    if (!parsed.message || typeof parsed.message !== "object") {
      return null;
    }
    const message = parsed.message as Partial<GigRequestMessageResponse>;
    if (
      typeof message.id !== "string" ||
      typeof message.requestId !== "string" ||
      typeof message.senderRole !== "string" ||
      typeof message.body !== "string" ||
      typeof message.createdAt !== "string"
    ) {
      return null;
    }

    return {
      type: "gig_request_message.created",
      message: {
        id: message.id,
        requestId: message.requestId,
        senderUserId: typeof message.senderUserId === "string" ? message.senderUserId : null,
        senderRole: message.senderRole,
        senderDisplayName: typeof message.senderDisplayName === "string" ? message.senderDisplayName : "Unknown user",
        body: message.body,
        createdAt: message.createdAt,
      },
    };
  } catch {
    return null;
  }
}
